import React from 'react';
import VScroll from "../../scrolling/custom-v-scroll/v-scroll";
import {
    REACTIONS_GESTURES,
    REACTIONS_NUMBERS,
    REACTIONS_OBJECTS, REACTIONS_SMILES,
    REACTIONS_SYMBOLS, ReactionsGroup
} from "../../../model2/reaction/const";
import AddReaction_ReactionsGroup from "./reactions-group";

type Props = {
    onSelect      : callback;
}

export default function AddReaction_AllReactions(props: Props) {

    const getFavoriteReactions = ()=>{
        return {
            name: "Favorite",
            reactions : gd.modules.reactions.favoriteReactions
        }
    }

    const isManager = gd.ac.check.company.isManager(gd.companyId);

    return (
        <div className="h-300">
            <VScroll className="ui5-popover-menu with-help p-t-0">
                <div className="all-reaction-items">
                    {!_.isEmpty(gd.modules.reactions.favoriteReactions) && <AddReaction_ReactionsGroup category={getFavoriteReactions()} onSelect={props.onSelect}/>}
                    <AddReaction_ReactionsGroup category={REACTIONS_GESTURES} onSelect={props.onSelect} className="m-t-10"/>
                    <AddReaction_ReactionsGroup category={REACTIONS_SMILES} onSelect={props.onSelect} className="m-t-10"/>
                    <AddReaction_ReactionsGroup category={REACTIONS_OBJECTS} onSelect={props.onSelect} className="m-t-10"/>
                    <AddReaction_ReactionsGroup category={REACTIONS_SYMBOLS} onSelect={props.onSelect} className="m-t-10"/>
                    <AddReaction_ReactionsGroup category={REACTIONS_NUMBERS} onSelect={props.onSelect} className="m-t-10"/>
                </div>
                {isManager && (
                    <div className="help">
                        <div className="ui5-link-small" onClick={()=>gd.goTo("settings/reactions")}>Manage reactions</div>
                    </div>
                )}
            </VScroll>
        </div>
    )

}